import React, { useState } from "react";
import axios from "axios";
import "../styles/deactivateUser.css";
import { getBackendUrl } from "../shared/static/constants.static";

const DeactivateUser: React.FC = () => {
  const [email, setEmail] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setShowAlert(true);
  };

  const handleConfirm = async () => {
    try {
      const backendUrl = getBackendUrl();
      await axios.put(`${backendUrl}/user/deactivate-by-email/${email}`);
      alert("Usuario eliminado exitosamente");
      setEmail("");
      setShowAlert(false);
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        alert(error.response.data.Error);
      } else {
        alert("A ocurrido un error inesperado");
      }
      console.error(error);
    }
  };

  const handleCancel = () => {
    setShowAlert(false);
  };

  return (
    <div className="deactivate-user-container">
      <span className="deactivate-user-title">Eliminar Datos del Usuario</span>
      <form onSubmit={handleSubmit} className="deactivate-user-form">
        <label htmlFor="email">Email del Usuario:</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Eliminar Usuario</button>
      </form>
      {showAlert && (
        <div className="alert">
          <p>¿Estás seguro que quieres eliminar los datos de este usuario de mi Diario de Salud?</p>
          <button onClick={handleConfirm}>
            Sí
          </button>
          <button onClick={handleCancel}>
            No
          </button>
        </div>
      )}
    </div>
  );
};

export default DeactivateUser;
